import { useMemo } from 'react'

import { Scope } from '../../../enums/scope'
import { isAuthorized } from '../../../utils/isAuthorized'
import type { InvoicingSettingsEntryContext } from '../enums/invoicingSettingsEntryContext'
import type { InvoicingSettingsSection } from '../enums/invoicingSettingsSection'
import { getVisibleInvoicingSettingsSections } from '../utils/getVisibleInvoicingSettingsSections'

export const useVisibleInvoicingSettingsSections = (
  entryContext?: InvoicingSettingsEntryContext,
): InvoicingSettingsSection[] => {
  const canReadEDocuments = isAuthorized(Scope.EDocumentRead)

  return useMemo(
    () => getVisibleInvoicingSettingsSections({ canReadEDocuments, entryContext }),
    [canReadEDocuments, entryContext],
  )
}
